import NotificationCard from "./NotificationCard";

function NotificationList({ notifications, expandedIds, onToggle }) {
  return (
    <div className="nt-list" data-testid="notifications-list">
      {notifications.map((reminder) => (
        <NotificationCard
          key={`nt-${reminder.id}`}
          reminder={reminder}
          isOpen={expandedIds.has(reminder.id)}
          onToggle={() => onToggle(reminder.id)}
        />
      ))}
    </div>
  );
}

export default NotificationList;
